import { connect } from 'react-redux';
import { ErrorsType } from '../../types/ErrorsType';
import React, { useEffect, useRef, useState } from 'react';
import NotificationSystem from 'react-notification-system';
import { ValidationPopUpProps } from './ValidationPopUp.types';
import * as actions from '../../actions/dashboardActionCreators';

const ValidationPopUp = ({ errors, errorTime }: ValidationPopUpProps) => {
  const VALIDATION_POPUP_TIMEOUT = 20;

  const [_parsedErrors, setParsedErrors] = useState<string[]>([]);
  const notificationSystemRef = useRef<NotificationSystem.System>(null);

  const splitCompoundMessage = (msg: string): string[] => {
    const withNewlines = msg.replace(/\\n/g, '\n');
    const lines = withNewlines
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);
    return lines.length > 0 ? lines : [];
  };

  const parseErrors = (errors: ErrorsType): string[] => {
    if (Array.isArray(errors)) {
      return errors.flatMap((error) =>
        typeof error === 'string' ? splitCompoundMessage(error) : parseErrors(error)
      );
    }

    if (typeof errors === 'object' && errors !== null) {
      return Object.values(errors).flatMap((error) => parseErrors(error));
    }

    if (typeof errors === 'string') {
      return splitCompoundMessage(errors);
    }

    return [];
  };

  useEffect(() => {
    const parsed = parseErrors(errors ?? []);
    setParsedErrors(parsed);

    if (parsed.length > 0 && notificationSystemRef.current) {
      notificationSystemRef.current.clearNotifications();
      notificationSystemRef.current.addNotification({
        level: 'error',
        position: 'bc',
        title: 'Oops! We noticed some errors:',
        message: (
          <ul>
            {parsed.map((error, index) => (
              <li key={`${index}-${error}`}>{error}</li>
            ))}
          </ul>
        ),
        autoDismiss: VALIDATION_POPUP_TIMEOUT,
      });
    }
  }, [errors, errorTime]);

  return <NotificationSystem ref={notificationSystemRef} style={false} />;
};

const mapStateToProps = (state: any) => {
  const { errors, errorTime } = state.dashboard;
  return { errors, errorTime };
};

export default connect(mapStateToProps, actions)(ValidationPopUp);
